// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__SNRl4","Invalid":"Input_Invalid__3aeyU","Label":"Input_Label__3w96u"};